import { useEffect, useState } from "react";
import {
	loadPublicSiteConfig,
	type PublicSsoOauthLoginPresetLoaded,
	type PublicSiteIntegrationFlags,
} from "@Front/Services/PublicSiteConfig/publicSiteConfigLoader";

export type PublicIntegrationFlagsState = {
	ready: boolean;
	flags: PublicSiteIntegrationFlags;
	/** Server `SSO_OAUTH_CLIENT_ID` when API returns it (login SSO OAuth sans `NEXT_PUBLIC_*` au build). */
	sso_oauth_client_id: string | null;
	/** `GET /v1/public/site-config` → `__DATA_SSO_OAUTH_LOGIN_PRESETS__` (`sites.theme_json`). */
	__DATA_SSO_OAUTH_LOGIN_PRESETS__: readonly PublicSsoOauthLoginPresetLoaded[] | null;
};

const initialFlags: PublicSiteIntegrationFlags = {
	uses_idnot: false,
	uses_sso_oauth: false,
	uses_mailchimp: false,
	uses_ovh_sms: false,
	uses_stripe: false,
	allows_v1_import: false,
};

/**
 * Drapeaux `sites` exposés par `GET /v1/public/site-config` (admin multi-site).
 */
export function usePublicIntegrationFlags(): PublicIntegrationFlagsState {
	const [state, setState] = useState<PublicIntegrationFlagsState>({
		ready: false,
		flags: initialFlags,
		sso_oauth_client_id: null,
		__DATA_SSO_OAUTH_LOGIN_PRESETS__: null,
	});

	useEffect(() => {
		let cancelled = false;
		void loadPublicSiteConfig().then((cfg) => {
			if (!cancelled) {
				const raw = cfg.sso_oauth_client_id;
				const sso_oauth_client_id = typeof raw === "string" && raw.trim().length > 0 ? raw.trim() : null;
				const presets = cfg.__DATA_SSO_OAUTH_LOGIN_PRESETS__;
				const __DATA_SSO_OAUTH_LOGIN_PRESETS__ =
					Array.isArray(presets) && presets.length > 0 ? presets : null;
				setState({
					ready: true,
					flags: cfg.integration_flags,
					sso_oauth_client_id,
					__DATA_SSO_OAUTH_LOGIN_PRESETS__,
				});
			}
		});
		return (): void => {
			cancelled = true;
		};
	}, []);

	return state;
}
